/* eslint-disable */

export const accuracyPreparedVolumeSell = {
    GET_ACCURACY_PREPEARED_VOLUME_SELL_REQUEST: 'GET_ACCURACY_PREPEARED_VOLUME_SELL_REQUEST',
    GET_ACCURACY_PREPEARED_VOLUME_SELL_SUCCESS: 'GET_ACCURACY_PREPEARED_VOLUME_SELL_SUCCESS',
    GET_ACCURACY_PREPEARED_VOLUME_SELL_FAILURE: 'GET_ACCURACY_PREPEARED_VOLUME_SELL_FAILURE',
};
